export const sliderItems = [
    {
      id: 1,
      img: "https://www.pngarts.com/files/1/Fashion-PNG-Photo.png",
      title: "WINTER SALE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "f5fafd",
    },
    {
      id: 2,
      img: "https://images.unsplash.com/photo-1670531910262-5ddb5ad666ea?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHx0b3BpYy1mZWVkfDE5fFM0TUtMQXNCQjc0fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
      title: "AUTUMN COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fcf1ed",
    },
    {
      id: 3,
      img: "https://images.unsplash.com/photo-1643646018270-3e47f410521a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHx0b3BpYy1mZWVkfDU2fFM0TUtMQXNCQjc0fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
      title: "LOUNGEWEAR LOVE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fbf0f4",
    },
  ];

  export const categories = [
    {
      id: 1,
      
      img: "https://images.unsplash.com/photo-1670911170630-c9acad2e9da7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHx0b3BpYy1mZWVkfDJ8UzRNS0xBc0JCNzR8fGVufDB8fHx8&auto=format&fit=crop&w=600&q=60",
      title: "SHIRT STYLE!",
      cat:"men"
    },
    {
      id: 2,
      img: "https://images.unsplash.com/photo-1671094362390-02b76f5e0556?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHx0b3BpYy1mZWVkfDV8UzRNS0xBc0JCNzR8fGVufDB8fHx8&auto=format&fit=crop&w=600&q=60",
      title: "LOUNGEWEAR LOVE",
      cat:"women"
    },
    {
      id: 3,
      img: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8aGVhZHNldHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60",
      title: "BEST DEALS",
      cat:"edivice"
    },
  ];

  export const popularProducts = [
    {
      id:1,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
    },
    {
      id:2,
      img:"https://media.istockphoto.com/id/482948743/photo/blank-white-t-shirt-front-with-clipping-path.jpg?b=1&s=170667a&w=0&k=20&c=0ZVjmNfhpgTmkvGZk2Um2UnZEdTT14rcUsQeTBmhuWA=",
    },
    {
      id:3,
      img:"https://media.istockphoto.com/id/483960103/photo/blank-black-t-shirt-front-with-clipping-path.jpg?b=1&s=170667a&w=0&k=20&c=BcPtyKJxhRevZV29PDZ1y-le2WbmH6Xf4O_lkmopDxg=",
    },
    {
      id:4,
      img:"https://freepngimg.com/thumb/dress/31400-4-dress-transparent.png",
    },
    {
      id:5,
      img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
    },
    {
      id:6,
      img:"./img/iSHOP Logo.svg",
    },
    {
      id:7,
      img:"../img/e10.png",
    },
    {
      id:8,
      img:"https://www.pngmart.com/files/8/Dress-Shirt-PNG-Clipart-Background.png",
    },
  ]


  // https://freepngimg.com/thumb/categories/564.png
  // https://freepngimg.com/thumb/categories/598.png
  // https://freepngimg.com/thumb/categories/616.png
  // https://freepngimg.com/thumb/categories/621.png
  // https://freepngimg.com/thumb/categories/626.png
  // https://image.shutterstock.com/image-photo/many-jeans-hanging-on-rack-260nw-1108204754.jpg
  
  
  // https://pngimg.com/uploads/jeans/small/jeans_PNG5772.png
  // https://pngimg.com/uploads/jacket/small/jacket_PNG8049.png
  // https://pngimg.com/uploads/jacket/small/jacket_PNG8051.png
  // https://pngimg.com/uploads/jacket/small/jacket_PNG8054.png
  // https://pngimg.com/uploads/jeans/small/jeans_PNG5770.png
  
  // https://pngimg.com/uploads/jacket/small/jacket_PNG8057.png
  // https://spng.pngfind.com/pngs/s/124-1245557_poison-beaker-t-shirt-blues-brothers-t-shirt.png
  // https://pngimg.com/uploads/jeans/small/jeans_PNG5745.png
  // https://www.freepnglogos.com/uploads/t-shirt-png/t-shirt-png-black-shirt-png-transparent-image-pngpix-2.png
  // https://pngimg.com/uploads/tshirt/small/tshirt_PNG5444.png
  // https://pngimg.com/uploads/jacket/small/jacket_PNG8027.png
  // https://pngimg.com/uploads/jeans/small/jeans_PNG5747.png
  // https://pngimg.com/uploads/tshirt/small/tshirt_PNG5437.png